
<template>
   <v-layout row wrap class="border">
      <v-flex class="xs12 sm8">
         <div class="flex-container">
            <galva class="left-element" name="ÉNERGIE" :size="120" :domain="{inf: 0., sup: nutrientLimSupDict['208']}" :norm="{ d1: nutrientRangeDict['208'].d1, d2: nutrientRangeDict['208'].d2, dt1: nutrientRangeDict['208'].dt1, dt2: nutrientRangeDict['208'].dt2, h: 0}" :value="{ d1: nutrientDict['208'].d1, d2: nutrientDict['208'].d2, dt1: nutrientDict['208'].dt1, dt2: nutrientDict['208'].dt2, h: 0}"></galva>
            <galva class="left-element" name="LIPIDES" :size="100" :domain="{inf: 0., sup: nutrientLimSupDict['204']}" :norm="{ d1: nutrientRangeDict['204'].d1, d2: nutrientRangeDict['204'].d2, dt1: nutrientRangeDict['204'].dt1, dt2: nutrientRangeDict['204'].dt2, h: 0}" :value="{ d1: nutrientDict['204'].d1, d2: nutrientDict['204'].d2, dt1: nutrientDict['204'].dt1, dt2: nutrientDict['204'].dt2, h: 0}"></galva>
            <galva class="left-element" name="GLUCIDES" :size="100" :domain="{inf: 0., sup: nutrientLimSupDict['205']}" :norm="{ d1: nutrientRangeDict['205'].d1, d2: nutrientRangeDict['205'].d2, dt1: nutrientRangeDict['205'].dt1, dt2: nutrientRangeDict['205'].dt2, h: 0}" :value="{ d1: nutrientDict['205'].d1, d2: nutrientDict['205'].d2, dt1: nutrientDict['205'].dt1, dt2: nutrientDict['205'].dt2, h: 0}"></galva>
            <galva class="left-element" name="PROTIDES" :size="100" :domain="{inf: 0., sup: nutrientLimSupDict['203']}" :norm="{ d1: nutrientRangeDict['203'].d1, d2: nutrientRangeDict['203'].d2, dt1: nutrientRangeDict['203'].dt1, dt2: nutrientRangeDict['203'].dt2, h: 0}" :value="{ d1: nutrientDict['203'].d1, d2: nutrientDict['203'].d2, dt1: nutrientDict['203'].dt1, dt2: nutrientDict['203'].dt2, h: 0}"></galva>
         </div>
      </v-flex>
               
      <v-flex class="xs12 sm4">
         <div class="flex-container">
            <badge class="right-element" :mark="mealMark" :size="120" backColor="#8c6e64" frontColor="white"/>
         </div>
      </v-flex>
   </v-layout>
</template>

<script>
   import Galva from '@/components/nutrieduc/Galva.vue'
   import Badge from '@/components/nutrieduc/Badge.vue'
   import fuzzy from '@/utilities/fuzzy.js'
   import nutrition from '@/utilities/nutrition/nutrition.js'

   export default {

      components: {
         Galva: Galva,
         Badge: Badge,
      },

      props: {
         userId: Number,
         date: String,
         index: Number,
      },

      data () {
         return {
            nutrnoArray: ['208', '204', '205', '203']
         }
      },

      computed: {
         mealId() {
            if (this.$store.state.meals.user2date2index2meal[this.userId]
                  && this.$store.state.meals.user2date2index2meal[this.userId][this.date]
                  && this.$store.state.meals.user2date2index2meal[this.userId][this.date][this.index]) {
               return this.$store.state.meals.user2date2index2meal[this.userId][this.date][this.index]
            } else {
               return null
            }
         },
         meal() {
            if (this.mealId) {
               return this.$store.state.meals.meals[this.mealId]
            } else {
               return null
            }
         },
         mealElements() {
            if (this.$store.state.meals.meal2mealElementList.hasOwnProperty(this.mealId)) {
               return this.$store.state.meals.meal2mealElementList[this.mealId].map(mealElementId => this.$store.state.meals.mealElements[mealElementId])
            } else {
               return []
            }
         },

         mealElementWeights() {
            return this.mealElements.map(mealElement => {
               return fuzzy.parse(mealElement.weight)
            })
         },

         user() {
            return this.$store.state.users[this.userId]
         },
         nutrients() {
            return this.nutrnoArray.map(nutr_no => this.$store.state.meals.nutrients[nutr_no])
         },
         rda() {
            return this.user.extra.gender === "M" ? 8.8 * this.user.extra.height + 932. : 17.5 * this.extra.height - 700.
         },
         fractionning() {
            if (this.userId && this.date && this.$store.state.meals.user2date2fractionning[this.userId] && this.$store.state.meals.user2date2fractionning[this.userId][this.date]) {
               let fractionningId = this.$store.state.meals.user2date2fractionning[this.userId][this.date]
               return this.$store.state.meals.fractionnings[fractionningId]
            } else {
               return null
            }
         },
         fractionningCategory() {
            return nutrition.evaluateFractionning(this.fractionning)
         },

         mealPercentage() {
            let isDiabetic = false
            let lowCalories = !isDiabetic && this.rda < 1600
            return nutrition.getMealPercentage(this.fractionningCategory, lowCalories, this.index)
         },
         mealEnergy() {
            return this.rda * this.mealPercentage * 0.01
         },

         nutrientRangeDict() {
            let dict = {}
            let mealEnergy = this.rda * this.mealPercentage * 0.01
            this.nutrnoArray.forEach(nutr_no => {
               let nutrient = this.$store.state.meals.nutrients[nutr_no]
               dict[nutr_no] = nutrient ? nutrition.getNutrientAbsoluteRange(this.user, nutrient, mealEnergy) : { d1: 0, d2: 0, dt1: 0, dt2: 0, h: 0 }
            })
            return dict
         },
         nutrientLimSupDict() {
            let dict = {}
            let mealEnergy = this.rda * this.mealPercentage * 0.01
            this.nutrnoArray.forEach(nutr_no => {
               let nutrient = this.$store.state.meals.nutrients[nutr_no]
               dict[nutr_no] = nutrient ? nutrition.getNutrientLimSup(nutrient, mealEnergy) : 0.
            })
            return dict
         },

         nutrientArray() {
            return this.nutrnoArray.map(nutr_no => nutrition.computeNutrientValue(nutr_no, this.mealElements,
               this.$store.state.meals.foods, this.$store.state.meals.foodPortions, this.$store.state.meals.nutdatas, this.$store.state.meals.food2nutrient2nutdata
            ))
         },

         nutrientDict() {
            let dict = {}
            this.nutrnoArray.forEach((nutrno, index) => {
               dict[nutrno] = this.nutrientArray[index]
            })
            return dict
         },

         mealScore() {
            return nutrition.getMealScore(this.user, this.nutrients, this.mealElements, this.mealEnergy,
               this.$store.state.meals.foods, this.$store.state.meals.foodPortions, this.$store.state.meals.nutdatas, this.$store.state.meals.food2nutrient2nutdata
            )
         },
         mealMark() {
            let score10 = this.mealScore * 10.
            return score10.toLocaleString('fr-FR', {maximumSignificantDigits: 2})
         }

      },

      methods: {
         isMealPresent(index) {
            return nutrition.isMealPresent(this.fractionning, index)
         },
      },
   }
</script>


<style scoped>

.flex-container {
   display: flex;
   align-items: baseline;
}

.left-element {
}

.right-element {
   margin-left: auto;
}

.border {
   border: solid 1px #ccc;
}

</style>



// WEBPACK FOOTER //
// MealAssessment.vue?eeb95776